// extracted by mini-css-extract-plugin
export var activeLink = "navigation-module--activeLink--c294e";
export var black = "navigation-module--black--a6c64";
export var desktop = "navigation-module--desktop--25dcb";
export var hamburgerButton = "navigation-module--hamburgerButton--08f96";
export var mobileLinks = "navigation-module--mobileLinks--44b74";
export var mobileMenu = "navigation-module--mobileMenu--3fd7d";
export var mobileMnu = "navigation-module--mobileMnu--03af4";
export var navLink = "navigation-module--navLink--851f5";
export var navStyle = "navigation-module--navStyle--a57f4";
export var white = "navigation-module--white--b22c6";